<div class="row" *ngIf='readOnly' role="main">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <ng-container *ngIf="isAustraliaChannel">
        <table class="table table-condensed">
          <tbody>
            <tr>
              <td class="col-sm-12 no-right-padding no-left-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Commercial Distribution End Date" class="col-sm-12">Commercial Distribution End Date</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Commercial Distribution End Date">
                        <label controlName="commercialDistributionEndDate"></label>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            
            <tr>
              <td class="col-sm-12 no-right-padding no-left-padding">
                <table formArrayName="artgForm" class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="ARTG ID" class="col-sm-2">ARTG ID</th>
                      <th role="columnheader" aria-label="Supporting Document URL" class="col-sm-3">Supporting Document URL</th>
                      <th role="columnheader" aria-label="Supporting Document Type" class="col-sm-2">Supporting Document Type</th>
                      <th role="columnheader" aria-label="Supporting Document Effective Date" class="col-sm-3">Supporting Document Effective Date</th>
                      <th role="columnheader" aria-label="Supporting Document End Date" class="col-sm-2">Supporting Document End Date</th>
                    </tr>
                    <ng-container *ngIf="artgForm.controls.length; else emptyTemplate5fields">
                      <tr formGroupName="{{i}}" *ngFor="let item of artgForm.controls; let i = index">
                        <td role="gridcell" aria-label="cell of ARTG ID">
                          <label controlName="artgId"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Supporting Document URL">
                          <label controlName="supportingDocumentUrl"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Supporting Document Type">
                          <label controlName="supportingDocumentType"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Supporting Document Effective Date">
                          <label controlName="supportingDocumentEffectiveDate"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Supporting Document End Date">
                          <label controlName="supportingDocumentEndDate"></label>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>

      <ng-container *ngIf="!isAustraliaChannel">
        <table class="table table-condensed">
          <tbody>
            <tr>
              <td class="col-sm-12 no-right-padding no-left-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Commercial Distribution End Date" class="col-sm-4">Commercial
                        Distribution End Date</th>
                      <th role="columnheader" aria-label="Device Exempt from FDA Premarket Submission?" class="col-sm-4">
                        Device Exempt from FDA Premarket Submission?</th>
                    </tr>
                    <tr>
                      <td role="gridcell">
                        <label aria-label="cell of Commercial Distribution End Date column"
                          controlName="commercialDistributionEndDate"> </label> </td>
                      <td role="gridcell"><label aria-label="cell of Device Exempt from FDA Premarket Submission? column"
                          controlName="premarketAuthorizationExempt"></label> </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="col-sm-6 no-left-padding no-right-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="FDA Premarket Submission Number(s)" class="col-sm-4">FDA
                        Premarket Submission Number(s)</th>
                      <th role="columnheader" aria-label="FDA Supplement Number(s)" class="col-sm-4">FDA Supplement
                        Number(s)</th>
                      <th role="columnheader" aria-label="FDA Listing Number(s)" class="col-sm-4">FDA Listing Number(s)
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <table formArrayName="premarketAuthorizationForm">
                          <tbody>
                            <ng-container *ngIf="premarketAuthorizationForm.controls.length; else emptyTemplate2fields">
                              <tr formGroupName="{{i}}"
                                *ngFor="let code of premarketAuthorizationForm.controls; let i = index">
                                <td role="gridcell" aria-label="cell of FDA Premarket Submission Number(s)"><label
                                    controlName="authorizationNumber"></label></td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table formArrayName="premarketAuthorizationForm">
                          <tbody>
                            <ng-container *ngIf="premarketAuthorizationForm?.controls?.length; else emptyTemplate2fields">
                              <tr formGroupName="{{i}}"
                                *ngFor="let code of premarketAuthorizationForm.controls; let i = index">
                                <td role="gridcell" aria-label="cell of FDA Supplement Number(s)"><label
                                    controlName="supplementNumber"></label></td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </td>
                      <td formArrayName="fdaListingNumbersForm">
                        <table>
                          <tbody>
                            <ng-container *ngIf="fdaListingNumbersForm?.controls?.length; else emptyTemplate1field">
                              <tr formGroupName="{{i}}"
                                *ngFor="let code of fdaListingNumbersForm.controls; let i = index">
                                <td role="gridcell" aria-label="cell of FDA Listing Number(s)"><label
                                    controlName="fdaListingNumber"></label></td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="col-sm-12 no-right-padding no-left-padding">
                <table class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>
                      <th role="columnheader" aria-label="Prescription Use (Rx)?" class="col-sm-4">Prescription Use (Rx)?
                      </th>
                      <th role="columnheader" aria-label="Over the Counter (OTC)?" class="col-sm-4">Over the Counter
                        (OTC)?</th>
                    </tr>
                    <tr>
                      <td role="gridcell" aria-label="cell of Prescription Use (Rx)?">
                        <label controlName="prescriptionUseRx"> </label> </td>
                      <td role="gridcell" aria-label="cell of Over the Counter (OTC)?">
                        <label controlName="overTheCounterOtc"> </label> </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="col-sm-12 no-right-padding no-left-padding">
                <table formArrayName="customerContactForm" class="table table-inner table-condensed table-striped">
                  <tbody>
                    <tr>

                      <th role="columnheader" aria-label="Customer Contact Phone - Country Code" class="col-sm-3">Customer
                        Contact Phone - Country Code</th>
                      <th role="columnheader" aria-label="Customer Contact Phone - Area Code and Subscriber Number"
                        class="col-sm-3">Customer Contact Phone - Area Code and Subscriber Number</th>
                      <th role="columnheader" aria-label="Customer
                      Contact Phone - Extension" class="col-sm-2">Customer Contact Phone - Extension</th>
                      <th role="columnheader" aria-label="Customer Contact Email" class="col-sm-4">Customer Contact Email
                      </th>
                    </tr>
                    <ng-container *ngIf="customerContactForm.controls.length; else emptyTemplate4fields">
                      <tr formGroupName="{{i}}" *ngFor="let contact of customerContactForm.controls; let i = index">
                        <td role="gridcell" aria-label="cell of Customer Contact Phone - Country Code"><label
                            controlName="telCountryCode"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Customer Contact Phone - Area Code and Subscriber Number">
                          <label controlName="telNumber"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Customer Contact Phone - Extension"><label
                            controlName="extension"></label>
                        </td>
                        <td role="gridcell" aria-label="cell of Customer Contact Email"><label
                            controlName="email"></label>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </td>
            </tr>

          </tbody>
        </table>
      </ng-container>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field aria-hidden="true">
  <tr>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate2fields aria-hidden="true">
  <tr>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate3fields aria-hidden="true">
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate4fields aria-hidden="true">
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate5fields aria-hidden="true">
  <tr>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
    <td><label></label></td>
  </tr>
</ng-template>
